import { Box, Chip, Typography } from "@mui/material";
import WebhookRoundedIcon from "@mui/icons-material/WebhookRounded";

export const panelSx = {
  borderRadius: 3,
  border: "1px solid rgba(148,163,184,0.22)",
  background: "#FFFFFF",
  boxShadow: "0 10px 24px rgba(15,23,42,0.045)",
};

/** Fixed-height scroll area for data tables (endpoints, deliveries, API keys). */
export const scrollableTableContainerSx = {
  maxHeight: { xs: "52vh", sm: "56vh", md: "calc(100vh - 340px)" },
  minHeight: 240,
  overflow: "auto",
  border: "1px solid rgba(148,163,184,0.2)",
  borderRadius: 2,
  bgcolor: "#FAFBFC",
};

export const stickyTableHeadSx = {
  "& .MuiTableCell-head": {
    position: "sticky",
    top: 0,
    zIndex: 2,
    bgcolor: "#F1F5F9",
    fontWeight: 700,
    fontSize: 12,
    color: "#475569",
    borderBottom: "1px solid rgba(148,163,184,0.35)",
    whiteSpace: "nowrap",
  },
};

const DELIVERY_STATUS = {
  pending: { label: "Pending", color: "#92400E", bg: "rgba(245,158,11,0.14)" },
  processing: { label: "Processing", color: "#1D4ED8", bg: "rgba(59,130,246,0.14)" },
  delivered: { label: "Delivered", color: "#166534", bg: "rgba(22,163,74,0.14)" },
  failed: { label: "Failed", color: "#B91C1C", bg: "rgba(239,68,68,0.14)" },
  cancelled: { label: "Cancelled", color: "#475569", bg: "rgba(100,116,139,0.12)" },
};

export function deliveryStatusChip(status) {
  const key = (status || "pending").toLowerCase();
  const tone = DELIVERY_STATUS[key] || DELIVERY_STATUS.pending;
  return (
    <Chip
      size="small"
      label={tone.label}
      sx={{
        fontWeight: 700,
        bgcolor: tone.bg,
        color: tone.color,
        border: "1px solid rgba(148,163,184,0.2)",
      }}
    />
  );
}

export function PageShell({ title, subtitle, actions, children }) {
  return (
    <Box sx={{ maxWidth: 1400, mx: "auto", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2.5,
              display: "grid",
              placeItems: "center",
              bgcolor: "rgba(14,165,233,0.12)",
              color: "#0369A1",
            }}
          >
            <WebhookRoundedIcon />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 800, color: "#0F172A" }}>
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" sx={{ color: "#64748B", mt: 0.5 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Box>
        {actions ? <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{actions}</Box> : null}
      </Box>
      {children}
    </Box>
  );
}
